import {createStore, applyMiddleware} from 'redux';
import {combineReducers, compose} from 'redux';
import createSagaMiddleware from 'redux-saga';
import {all} from 'redux-saga/effects';
import {IS_CLIENT, ENV_NAME} from './constant';
import common, {IStateCommon} from './state/reducer';
import commonSaga from './state/saga';
import {PStore} from './type';
import {assert} from './util/assert';
import auth, {IStateAuth} from '../auth/state/reducer';
import authSaga from '../auth/state/saga';
import comment, {IStateComment} from '../comment/state/reducer';
import commentSaga from '../comment/state/saga';
import commonSub, {IStateCommonSub} from '../commonSub/state/reducer';
import commonSubSaga from '../commonSub/state/saga';
import content, {IStateContent} from '../content/state/reducer';
import contentSaga from '../content/state/saga';
import event, {IStateEvent} from '../event/state/reducer';
import eventSaga from '../event/state/saga';
import gift, {IStateGift} from '../gift/state/reducer';
import giftSaga from '../gift/state/saga';
import home, {IStateHome} from '../home/common/state/reducer';
import homeSaga from '../home/common/state/saga';
import myPage, {IStateMyPage} from '../home/myPage/state/reducer';
import ranking, {IStateRanking} from '../home/ranking/state/reducer';
import timeTable, {IStateTimeTable} from '../home/timeTable/state/reducer';
import luckydraw, {IStateLuckydraw} from '../luckydraw/state/reducer';
import luckydrawSaga from '../luckydraw/state/saga';
import more, {IStateMore} from '../more/state/reducer';
import moreSaga from '../more/state/saga';
import search, {IStateSearch} from '../search/state/reducer';
import searchSaga from '../search/state/saga';
import viewer, {IStateViewer} from '../viewer/state/reducer';
import viewerSaga from '../viewer/state/saga';

export interface IReduxState {
  auth: IStateAuth;
  common: IStateCommon;
  commonSub: IStateCommonSub;
  home: IStateHome;
  ranking: IStateRanking;
  more: IStateMore;
  content: IStateContent;
  search: IStateSearch;
  comment: IStateComment;
  viewer: IStateViewer;
  myPage: IStateMyPage;
  luckydraw: IStateLuckydraw;
  gift: IStateGift;
  timeTable: IStateTimeTable;
  event: IStateEvent;
}

const combinedReducer = combineReducers<IReduxState>({
  auth,
  common,
  commonSub,
  home,
  ranking,
  more,
  content,
  search,
  comment,
  viewer,
  myPage,
  luckydraw,
  gift,
  timeTable,
  event,
});

const makeStore = (initialState?: IReduxState): PStore => {
  const sagaMiddleware = createSagaMiddleware();
  function* rootSaga() {
    yield all([
      authSaga(),
      commonSubSaga(),
      commonSaga(),
      homeSaga(),
      moreSaga(),
      contentSaga(),
      searchSaga(),
      commentSaga(),
      viewerSaga(),
      luckydrawSaga(),
      giftSaga(),
      eventSaga(),
    ]);
  }
  const composeEnhancers =
    (IS_CLIENT &&
      ENV_NAME === 'local' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const store: PStore = createStore(
    combinedReducer,
    initialState,
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );
  store.sagaTask = sagaMiddleware.run(rootSaga);
  return store;
};

let pStore: PStore | undefined;
export const getStore = (initialState?: IReduxState) => {
  const _store = pStore ?? makeStore(initialState);

  if (IS_CLIENT && !pStore) {
    pStore = _store;
  }

  return _store;
};

export function getClientStore(): PStore | undefined {
  assert(
    IS_CLIENT,
    'getClientStore 함수는 클라이언트 사이드에서만 호출해야합니다'
  );
  return getStore();
}
